import { render } from "./InputFieldTemplate.vue?vue&type=template&id=35c88f1c"
import script from "./InputFieldTemplate.vue?vue&type=script&lang=js"
export * from "./InputFieldTemplate.vue?vue&type=script&lang=js"

import "./InputFieldTemplate.vue?vue&type=style&index=0&id=35c88f1c&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__